<form>
  <mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      autocomplete="off"
      type="text"
      (blur)="onBlur()"
      (keydown)="$event.stopPropagation()"
      (keyup.enter)="$event.target.blur()"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      #searchInput
    />
  </mat-form-field>
</form>
